import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PlanManager from "./PlanManager";
import '../../../styles/VBAMaintenance.css';
import GroupManager from "./GroupManager";
import DivisionManager from "./DivisionManager";
import BulkUpdateFileDrop from "../BulkFiles/BulkUpdateFileDrop";


function VBAMaintenance() {
    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);

    const handleTabChange = (e : any, tabIndex : any) => {
        //console.log(tabIndex);
        setCurrentTabIndex(tabIndex);
    };

    return (
        <div style={{height: "100%", width: "100%"}}>
            <React.Fragment>
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={currentTabIndex}
                    onChange={handleTabChange}
                    aria-label="Vertical tabs example"
                    sx={{ borderRight: 1, borderColor: 'divider', borderRadius: '10px', maxWidth: '15%'}}
                    className="tabStyles"
                >
                    <Tab label="Plan Maintenance" style={{fontWeight: "bolder"}}/>
                    <Tab label="Group Maintenance" style={{fontWeight: "bolder"}}/>
                    <Tab label="Group Divisions" style={{fontWeight: "bolder"}}/>
                    {/*<Tab label="Member Maintenance" style={{fontWeight: "bolder"}}/>*/}
                    <Tab label="Bulk Put File Drops" style={{fontWeight: "bolder"}}/>
                </Tabs>
                <span>
                    {currentTabIndex === 0 && <PlanManager></PlanManager>}
                    {currentTabIndex === 1 && <GroupManager></GroupManager>}
                    {currentTabIndex === 2 && <DivisionManager></DivisionManager>}
                    {currentTabIndex === 3 && <BulkUpdateFileDrop></BulkUpdateFileDrop>}
                </span>
            </React.Fragment>
        </div>
    )
}

export default React.memo(VBAMaintenance);